import { useTranslation } from "react-i18next";

import { Button } from "../../Button";

type DayPickerActionsProps = {
  onCancel: () => void;
  onApply: () => void;
};

const DayPickerActions = ({ onCancel, onApply }: DayPickerActionsProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-1 items-center justify-center gap-3 border-t border-gray-200 p-4">
      <Button
        intent="default"
        className="flex h-12 justify-center px-[3.0625rem]"
        onClick={onCancel}
      >
        {t("components.dayPicker.actions.cancel")}
      </Button>
      <Button
        intent="secondary"
        className="flex h-12 justify-center px-[3.0625rem]"
        onClick={onApply}
      >
        {t("components.dayPicker.actions.apply")}
      </Button>
    </div>
  );
};

export default DayPickerActions;
